module.exports = __webpack_public_path__ + "fonts/32b1fb8.ttf";